import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NetworkStatusService } from 'src/app/core/services/network/network-status.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-network-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './network-popup.component.html',
  styleUrls: ['./network-popup.component.scss']
})
export class NetworkPopupComponent implements OnInit, OnDestroy {
  isOnline: boolean = true;
  isRetrying: boolean = false;
  timer: number = 0;
  retryTimer: number = 30;
  interVel: any;
  showConnectedPopUp: boolean = false;

  private hasReconnected: boolean = false;  // Add this line
  private subscription: Subscription = new Subscription();

  constructor(private networkService: NetworkStatusService) { }

  ngOnInit() {
    this.isOnline = this.networkService.isOnline();
    this.subscription = this.networkService.online$.subscribe(
      status => {
        const wasOffline = !this.isOnline;
        this.isOnline = status;

        if (status) {
          this.timer = this.retryTimer;
          clearInterval(this.interVel);
          this.isRetrying = false;

          // Add this block for refresh logic
          if (wasOffline && !this.hasReconnected) {
            this.hasReconnected = true;
            this.showConnectedPopUp = true;
            setTimeout(() => {
              this.showConnectedPopUp = false;
            }
              , 2000);
          }
        } else {
          this.hasReconnected = false;  // Reset flag when offline
          this.startTimer();
        }
      }
    );
  }

  startTimer() {
    this.interVel = setInterval(() => {
      this.timer -= 1;
      if (this.timer === 0) {
        this.retryConnection();
      }
    }, 1000);
  }

  retryConnection() {
    if (this.isRetrying) return;
    this.isRetrying = true;
    clearInterval(this.interVel);
    this.timer = this.retryTimer;
    setTimeout(() => {
      this.isRetrying = false;
      this.startTimer();
      // The actual online/offline status will be handled by the subscription
    }, 3000);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}